module.exports = __webpack_public_path__ + "static/media/1007881.c9e34fbd.png";